"use client";
import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { usePostHog } from "posthog-js/react";

export function PostHogPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const posthog = usePostHog();

  useEffect(() => {
    // IMPORTANTE: Verifica che PostHog sia completamente caricato
    // prima di provare a tracciare eventi
    if (pathname && posthog && posthog.__loaded) {
      // Costruisci URL completo con query params
      const url =
        window.origin + pathname + (searchParams?.toString() ? `?${searchParams.toString()}` : "");

      try {
        // PostHog gestisce automaticamente l'opt-out
        // Se l'utente ha opt-out, questo evento non verrà inviato
        posthog.capture("$pageview", {
          $current_url: url,
        });
        console.log("📊 PostHog pageview tracked:", pathname);
      } catch (error) {
        console.debug("⚠️ PostHog pageview non tracciato:", error);
      }
    } else {
      // Debug: capire perché non viene tracciato
      if (!pathname) {
        console.debug("⏳ PostHogPageView: pathname non disponibile");
      } else if (!posthog) {
        console.debug("⏳ PostHogPageView: posthog client non disponibile");
      } else if (!posthog.__loaded) {
        console.debug("⏳ PostHogPageView: posthog non ancora caricato");
      }
    }
  }, [pathname, searchParams, posthog]);

  return null;
}
